import {
  FormLabel,
  ValidatedInput,
  ValidationMessage,
  Sidebar
} from "./../../../shared/components";
import MovedByEnum from "../../MovedByEnum";

import vSelect from 'vue-select';

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    ValidatedInput,
    ValidationMessage,
    FormLabel,
    Sidebar,
    'v-select': vSelect
  },
  data() {
    return {
      model: {
        drillRigId: 0,
        code: "",
        companyId: null,
        isActive : true,
        isAutomated : false,
        movedBy: MovedByEnum.Trailer,
        drillingCapacity: null,
        length: null,
        width: null,
        height: null
      },
      movedByValues: MovedByEnum.definition
    };
  },
  computed : {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
        }
      }
    },
    companies() {
      return this.$store.state.drilling.companies;
    }
  },
  methods: {
    newData() {
      this.initValues();
      this.$refs.observer.reset();
    },
    editData() {
      this.model = structuredClone(this.data);
      this.$refs.observer.reset();
    },
    closeSidebar() {
      this.$emit("closeSidebar");
    },
    initValues() {
      if (this.data.drillRigId) return;
      this.model = {
        drillRigId: 0,
        code: "",
        companyId: null,
        isActive : true,
        isAutomated : false,
        movedBy: MovedByEnum.Trailer,
        drillingCapacity: null,
        length: null,
        width: null,
        height: null
      }
    },
    submitData() {
      this.$refs.observer.validate().then(result => {
        if (result) {
          const domainModel = this.model;
          this.$vs.loading();

          if (this.model.drillRigId !== null && this.model.drillRigId > 0) {
            this.$store.dispatch("drilling/updateDrill", domainModel).then((response) => {
              this.$emit("onUpdated", response.data.model);
            }).finally(() => {
              this.$vs.loading.close();
            });
          } else {
            this.$store.dispatch("drilling/addDrill", domainModel).then((response) => {
              this.$emit("onInserted", response.data.model);
              this.model.id = response.data.model;
            }).finally(() => {
              this.$vs.loading.close();
            });
          }
        }
      });
    }
  }
};
